export function lumijaGroup(item) {
  return item.properties?._lumija_set || item.properties?.['Lumija set'] || '';
}

export function incompleteLumijaSets(items) {
  const groups = new Map();
  for (const item of items) {
    const id = lumijaGroup(item);
    if (id) groups.set(id, [...(groups.get(id) || []), item]);
  }
  return [...groups.entries()].filter(([, lines]) => {
    const expected = String(lines[0].properties?._lumija_members || '').split(',');
    if (lines.length !== 3 || expected.length !== 3 || new Set(expected).size !== 3) return true;
    if (new Set(lines.map(line => line.properties?._lumija_role)).size !== 3) return true;
    return lines.some(line =>
      line.quantity !== 1 ||
      line.properties._lumija_members !== expected.join(',') ||
      !expected.includes(String(line.variant_id))
    ) || new Set(lines.map(line => String(line.variant_id))).size !== 3;
  }).map(([id]) => id);
}

const root = () => window.Shopify?.routes?.root || '/';
let changing = false;
function labels() {
  return JSON.parse(document.getElementById('lumija-set-labels')?.textContent || '{}');
}
function announce(text) {
  let output = document.getElementById('lumija-set-status');
  if (!output) {
    output = document.createElement('p');
    output.id = 'lumija-set-status';
    output.setAttribute('role', 'alert');
    output.style.cssText = 'padding:16px;border:2px solid #be787f;background:#fff0f1;color:#603b40;';
    const target = document.querySelector('[name="checkout"],#checkout');
    (target?.parentElement || document.querySelector('main') || document.body).append(output);
  }
  output.textContent = text;
  if (text) output.scrollIntoView({block:'center',behavior:'smooth'});
}
async function readCart() {
  const response = await fetch(root() + 'cart.js', {cache:'no-store'});
  if (!response.ok) throw Error(labels().error);
  return response.json();
}
export async function removeLumijaSet(group) {
  if (changing) return;
  changing = true;
  try {
    announce(labels().checking);
    const cart = await readCart();
    const lines = cart.items.filter(item => lumijaGroup(item) === group);
    if (!lines.length) { location.reload(); return; }
    const response = await fetch(root() + 'cart/update.js', {
      method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({updates:Object.fromEntries(lines.map(item => [item.key, 0]))})
    });
    if (!response.ok) throw Error(labels().error);
    const result = await response.json();
    if (result.items.some(item => lumijaGroup(item) === group)) throw Error(labels().error);
    location.reload();
  } catch {
    announce(labels().error);
    changing = false;
  }
}

if (typeof document !== 'undefined' && !window.lumijaSetGuardInstalled) {
  window.lumijaSetGuardInstalled = true;
  let checking = false;
  let permitted = null;
  async function validateAndContinue(target, resume) {
    if (checking || changing) return;
    checking = true;
    announce(labels().checking);
    try {
      const cart = await readCart();
      if (incompleteLumijaSets(cart.items).length) { announce(labels().incomplete); return; }
      announce('');
      permitted = target;
      resume();
    } catch { announce(labels().error); }
    finally { permitted = null; checking = false; }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[name="checkout"],#checkout,a[href$="/checkout"]');
    if (!button || permitted === button) return;
    event.preventDefault();event.stopImmediatePropagation();
    validateAndContinue(button, () => button.click());
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    const submitter = event.submitter;
    if (!submitter?.matches('[name="checkout"],#checkout') || permitted === submitter || permitted === form) return;
    event.preventDefault();event.stopImmediatePropagation();
    validateAndContinue(form, () => form.requestSubmit(submitter));
  }, true);
}
